<template>
    <Suspense>
        <RouterView v-slot="{ Component }">
            <Transition
                mode="out-in"
                appear
                :enter-active-class="enterActiveClass"
                :leave-active-class="leaveActiveClass">
                <component :is="Component"/>
            </Transition>
        </RouterView>
    </Suspense>
    
    <ModalHost/>
    <ContextMenuHost/>
    <NotificationsHost/>
    <ProgressBar/>
    <FloatingChat v-if="showFloatingChat"/>
</template>

<script setup lang="ts">
import ModalHost from '@/core/dialog/ModalHost.vue';
import ContextMenuHost from '@/core/context-menus/ContextMenuHost.vue';
import NotificationsHost from '@/core/notifications/NotificationsHost.vue';
import ProgressBar from '@/core/loading/ProgressBar.vue';
import { useAnimation } from '@/core/animation/animateComposable';
import FloatingChat from '@/core/components/chat/FloatingChat.vue';
import { computed } from 'vue';
import { userStore } from '@/core/store/user/user.store';
import { useRoute } from 'vue-router';
import { RouteNames } from '@/router/router.routes';

const { enterActiveClass, leaveActiveClass } = useAnimation({ type: 'fade' });
const route = useRoute();
const showFloatingChat = computed(() => route.name !== RouteNames.KYC_PUBLIC && !userStore.isLoggedIn.value);

</script>

<style>
#app {
    position: relative;

    display: flex;
    flex-direction: column;
    flex: 1 0 auto;

    background-color: theme('colors.background');
}
</style>
